import { ChangeEvent, useCallback } from 'react';

import { TextField, TextFieldProps } from '@material-ui/core';

import { FormFieldProps, useFormField } from '../../context';
import { withoutAutoFill } from '../../utils';

const TextFieldWithoutAutofill = withoutAutoFill(TextField);

export type NameFormFieldProps = Omit<TextFieldProps, 'value'> &
  FormFieldProps<string> & {
    loading?: boolean;
  };

export const NameFormField = ({
  field = 'displayName',
  initialValue = '',
  isRequired,
  onChange,
  loading,
  ...props
}: NameFormFieldProps) => {
  const { value, setValue } = useFormField(field, initialValue, { isRequired });

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onChange?.(e);
    },
    [onChange, setValue],
  );

  return (
    <TextFieldWithoutAutofill
      name={field}
      placeholder="Name"
      label="Name"
      value={value || ''}
      variant="outlined"
      margin="dense"
      onChange={handleChange}
      fullWidth
      disabled={loading}
      required
      inputProps={{
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: true,
        required: true,
        ...props.inputProps,
      }}
      {...props}
    />
  );
};
